/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable default-case */
import React, { useState, useEffect, useCallback } from "react";
import { ButtonsFilterTablesDiv } from "./styled";

const ButtonsFilterTables = ({ childToParent }) => {
 
  let arrayFiltro1;
  const filtro = localStorage.getItem('filtro');
  const filtroNome = localStorage.getItem('filtroNome');
  arrayFiltro1 = filtro?filtro.split(","):['false','false','false','false','false','false','false','false','false','false'];
  const arrayFiltro = arrayFiltro1.map((a)=>{
    if (a==='true') {
      return true;
    } else {
      return false
    }
  })

  const [checkedSeg, setCheckedSeg] = useState(arrayFiltro!=null ? arrayFiltro[0] : false);
  const [checkedTer, setCheckedTer] = useState(arrayFiltro!=null ? arrayFiltro[1] : false);
  const [checkedQua, setCheckedQua] = useState(arrayFiltro!=null ? arrayFiltro[2] : false);
  const [checkedQui, setCheckedQui] = useState(arrayFiltro!=null ? arrayFiltro[3] : false);
  const [checkedSex, setCheckedSex] = useState(arrayFiltro!=null ? arrayFiltro[4] : false);
  const [checkedSab, setCheckedSab] = useState(arrayFiltro!=null ? arrayFiltro[5] : false);
  const [checkedDom, setCheckedDom] = useState(arrayFiltro!=null ? arrayFiltro[6] : false);
  const [checkedFer, setCheckedFer] = useState(arrayFiltro!=null ? arrayFiltro[7] : false);
  const [checkedIda, setCheckedIda] = useState(arrayFiltro!=null ? arrayFiltro[8] : false);
  const [checkedVolta, setCheckedVolta] = useState(arrayFiltro!=null ? arrayFiltro[9] : false);
  
  useEffect(() => {
    var day = new Date(); //Pega o dia atual
    var weekday = day.getDay(); //retorna em número o dia da semana
    //Fica vigiando em que dia da semana estamos
    //0=Domingo 1=Segunda 2=Terça 3=Quarta 4=Quinta 5=Sexta 6=Sabado

    if(!filtroNome /* || ((arrayFiltroNome1.length===1 || arrayFiltroNome1.length===2) && (arrayFiltroNome1.includes('ida') || arrayFiltroNome1.includes('retorno')))*/){
     
      switch (weekday) {
        case 0:
          setCheckedDom(true);
          break;
        case 1:
          setCheckedSeg(true);
          break;
        case 2:
          setCheckedTer(true);
          break;
        case 3:
          setCheckedQua(true);
          break;
        case 4:
          setCheckedQui(true);
          break;
        case 5:
          setCheckedSex(true);
          break;
        case 6:
          setCheckedSab(true);
          break;
      }
    }
  }, []);

  useEffect(()=>{
    localStorage.setItem("filtro", [checkedSeg, checkedTer, checkedQua, checkedQui, checkedSex, checkedSab, checkedDom, checkedFer, checkedIda, checkedVolta])
  }, [checkedSeg, checkedTer, checkedQua, checkedQui, checkedSex, checkedSab, checkedDom, checkedFer, checkedIda, checkedVolta])

  const atualizar = useCallback(() => {
    var array = [];
    var checkboxes = document.querySelectorAll("input[type=checkbox]:checked");
    for (var i = 0; i < checkboxes.length; i++) {
      array.push(checkboxes[i].value);
    }
    childToParent(array);
    localStorage.setItem("filtroNome", array )
  }, [
    checkedSeg,
    checkedTer,
    checkedQua,
    checkedQui,
    checkedSex,
    checkedSab,
    checkedDom,
    checkedFer,
    checkedIda,
    checkedVolta,
  ]);

  useEffect(() => {
    atualizar();
  }, [atualizar]);

  return (
    <ButtonsFilterTablesDiv>
      <div className="checkbox-buttons-container">
        <input
          type="checkbox"
          id="Ida"
          value="ida"
          checked={checkedIda}
          onChange={() => {
            setCheckedIda(!checkedIda);
            // childToParent({ ida: !checkedIda });
          }}
        />
        <label htmlFor="Ida">Ida</label>
        <input
          type="checkbox"
          id="Volta"
          value="retorno"
          checked={checkedVolta}
          onChange={() => {
            setCheckedVolta(!checkedVolta);
            // childToParent({ retorno: !checkedVolta });
          }}
        />
        <label htmlFor="Volta" className="retorno">
          Retorno
        </label>
        <input
          type="checkbox"
          id="Seg"
          value="seg"
          checked={checkedSeg}
          // checked={arrayFiltro!=null ? arrayFiltro[0] :checkedSeg}
          onChange={() => {
            setCheckedSeg(!checkedSeg);
            // setCheckedSeg(arrayFiltro!=null ? !arrayFiltro[0] : !checkedSeg);
            // childToParent({ seg: !checkedSeg });
          }}
        />
        <label htmlFor="Seg">Seg</label>
        <input
          type="checkbox"
          id="Ter"
          value="ter"
          checked={checkedTer}
          onChange={() => {
            setCheckedTer(!checkedTer);
            // childToParent({ ter: !checkedTer });
          }}
        />
        <label htmlFor="Ter">Ter</label>
        <input
          type="checkbox"
          id="Qua"
          value="qua"
          checked={checkedQua}
          onChange={() => {
            setCheckedQua(!checkedQua);
            // childToParent({ qua: !checkedQua });
          }}
        />
        <label htmlFor="Qua">Qua</label>
        <input
          type="checkbox"
          id="Qui"
          value="qui"
          checked={checkedQui}
          onChange={() => {
            setCheckedQui(!checkedQui);
            // childToParent({ qui: !checkedQui });
          }}
        />
        <label htmlFor="Qui">Qui</label>
        <input
          type="checkbox"
          id="Sex"
          value="sex"
          checked={checkedSex}
          onChange={() => {
            setCheckedSex(!checkedSex);
            // childToParent({ sex: !checkedSex });
          }}
        />
        <label htmlFor="Sex">Sex</label>
        <input
          type="checkbox"
          id="Sab"
          value="sab"
          checked={checkedSab}
          onChange={() => {
            setCheckedSab(!checkedSab);
            // childToParent({ sab: !checkedSab });
          }}
        />
        <label htmlFor="Sab">Sab</label>
        <input
          type="checkbox"
          id="Dom"
          value="dom"
          checked={checkedDom}
          onChange={() => {
            setCheckedDom(!checkedDom);
            // childToParent({ dom: !checkedDom });
          }}
        />
        <label htmlFor="Dom">Dom</label>
        <input
          type="checkbox"
          id="Fer"
          value="feriado"
          checked={checkedFer}
          onChange={() => {
            setCheckedFer(!checkedFer);
            // childToParent({ feriado: !checkedFer });
          }}
        />
        <label htmlFor="Fer" className="fer">
          Feriado
        </label>
      </div>
    </ButtonsFilterTablesDiv>
  );
};

export default ButtonsFilterTables;
